import { useEffect, useState } from "react";
import { ApiList } from "../Config/ApiList";
import AxiosInstance from "../Config/AxiosInstance";

const useSignUrl = (url) => {
  const [imageUrl, setImageUrl] = useState("");
  useEffect(() => {
    const getImageurl = async () => {
      if (!url) return;
      const response = await AxiosInstance.get(ApiList.getImageUrl, { params: { url } });
      if (response?.data?.s === 1) {
        setImageUrl(response?.data?.r);
      }
    };
    getImageurl();
  }, [url]);
  return imageUrl;
};

export default useSignUrl;